import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import OpalCard from '../../../../components/opal/OpalCard'

function LinkCard ({ to, children }) {
  return (
    <Link className='rich' to={to}>
      <OpalCard className='font-serif p-lg opal-selectable' style={{ backgroundColor: 'var(--dai-color-surface3)' }}>
        {children}
      </OpalCard>
    </Link>
  )
}

LinkCard.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node
}

export default LinkCard
